import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';
import { VisuallyLogo } from '@/features/strapi/components/logo';
import { AccountContext } from '@/features/account-context';
import {
  MobileMenuButton,
  useMobileMenu,
} from '@/components/mobile-menu/button';
import { MobileMenuOverlay } from '@/components/mobile-menu/overlay';
import { StrapiTextual } from '@/features/strapi/components/textual';
import {
  OverlayType,
  showOverlay,
} from '@/features/common-overlays/overlay-manager';

export function MobileDashboardHeader() {
  const ctx = useContext(AccountContext);
  const siteName = useMemo(
    () =>
      ctx?.account?.store?.domain
        ?.replace(`https://`, ``)
        ?.replace(`www.`, ``)
        ?.replace(`.myshopify.com`, ``),
    [ctx],
  );

  const { isMenuOpen, openMenu, closeMenu } = useMobileMenu();

  const onFriendReferralClick = () => {
    showOverlay(OverlayType.REFER_A_FRIEND);
    closeMenu();
  };

  const onLogout = () => {
    ctx.logout();
  };

  return (
    <Wrapper className="only-mobile">
      <VisuallyLogo small />
      <SiteName>{siteName || `Visually`}</SiteName>
      <MobileMenuButton onClick={openMenu} />
      {isMenuOpen && (
        <MobileMenuOverlay
          header={
            <MenuHeader>
              <VisuallyLogo small />
              <SiteName>{siteName || `Visually`}</SiteName>
            </MenuHeader>
          }
          onBackdropClicked={closeMenu}
          onClose={closeMenu}
        >
          <StrapiTextual href="/dashboard" text="Live" />
          <StrapiTextual
            className="disabled"
            href="#"
            text="Audiences (Desktop Only)"
          />
          <StrapiTextual
            className="disabled"
            href="#"
            text="Reports (Desktop Only)"
          />
          <StrapiTextual
            href="/dashboard?pg=INSPIRATIONS"
            text="Inspirations"
          />
          <StrapiTextual href="/accounts" text="Connected Stores" />
          <StrapiTextual href="https://help.visually.io" text="Help Center" />
          <StrapiTextual href="#" onClick={onLogout} text="Logout" />
          <Divider />
          <ShareButton onClick={onFriendReferralClick}>
            Share the ❤️ and get up to $1500
          </ShareButton>
        </MobileMenuOverlay>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  max-width: 100vw;
  width: 100%;
  background: white;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  padding: 2rem 2rem;
  gap: 1.5rem;

  .disabled {
    opacity: 0.3;
    pointer-events: none;
  }
`;

const MenuHeader = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 1.5rem;
`;

const SiteName = styled.span`
  font-family: 'Inter', serif;
  font-size: 1.4rem;
  text-transform: uppercase;
  font-weight: bold;
  color: black;
  max-width: 20rem;
  letter-spacing: -0.79px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e1e4e8;
`;

const ShareButton = styled.button`
  font-family: Eesti, serif;
  outline: none;
  border: none;
  text-decoration: underline;
  text-align: start;
  font-size: 1.8rem;
  cursor: pointer;
  color: black !important;
`;
